import { PaginatedResponse } from './common.type';

export interface ProcessingCenterSchema {
  id: string;
  name: string;
  location: string;
  capacity: number;
  status: 'active' | 'inactive' | 'maintenance';
  created_at: string;
  updated_at: string;
}

export interface ProcessingQueueSchema {
  id: string;
  center_id: string;
  material_type: string;
  quantity: number;
  status: 'pending' | 'processing' | 'completed' | 'failed';
  priority: number;
  created_at: string;
  updated_at: string;
}

export interface QualityControlSchema {
  id: string;
  queue_id: string;
  center_id: string;
  quality_score: number;
  notes: string;
  status: 'passed' | 'failed' | 'pending';
  created_at: string;
  updated_at: string;
}

export interface ProcessingCenterRequest {
  name: string;
  location: string;
  capacity: number;
  status: 'active' | 'inactive' | 'maintenance';
}

export interface ProcessingQueueRequest {
  center_id: string;
  material_type: string;
  quantity: number;
  priority: number;
}

export interface QualityControlRequest {
  queue_id: string;
  center_id: string;
  quality_score: number;
  notes: string;
  status: 'passed' | 'failed' | 'pending';
}

export interface UpdateProcessingCenterRequest {
  name?: string;
  location?: string;
  capacity?: number;
  status?: 'active' | 'inactive' | 'maintenance';
}

export interface UpdateProcessingQueueRequest {
  status?: 'pending' | 'processing' | 'completed' | 'failed';
  priority?: number;
}

export interface UpdateQualityControlRequest {
  quality_score?: number;
  notes?: string;
  status?: 'passed' | 'failed' | 'pending';
}

export interface ProcessingQueryParams {
  page?: number;
  limit?: number;
  sort_by?: string;
  sort_order?: 'asc' | 'desc';
  status?: ProcessingStatus;
  type?: ProcessingType;
  priority?: ProcessingPriority;
  material_type?: string;
  assigned_to?: string;
  start_date?: string;
  end_date?: string;
  search?: string;
}

export interface ProcessingBatchSchema {
  id: string;
  batch_number: string;
  status: ProcessingStatus;
  type: ProcessingType;
  priority: ProcessingPriority;
  material_type: string;
  quantity: number;
  unit: string;
  start_date?: string;
  end_date?: string;
  created_at: string;
  updated_at: string;
  notes?: string;
  quality_score?: number;
  efficiency_score?: number;
  assigned_to?: string;
  assigned_to_name?: string;
  metadata?: Record<string, any>;
}

export enum ProcessingStatus {
  PENDING = 'PENDING',
  IN_PROGRESS = 'IN_PROGRESS',
  QUALITY_CHECK = 'QUALITY_CHECK',
  COMPLETED = 'COMPLETED',
  CANCELLED = 'CANCELLED',
  ON_HOLD = 'ON_HOLD'
}

export enum ProcessingType {
  SORTING = 'SORTING',
  CLEANING = 'CLEANING',
  SHREDDING = 'SHREDDING',
  COMPACTING = 'COMPACTING',
  CUSTOM = 'CUSTOM'
}

export enum ProcessingPriority {
  LOW = 'LOW',
  MEDIUM = 'MEDIUM',
  HIGH = 'HIGH',
  URGENT = 'URGENT'
}

export interface ProcessingBatchRequest {
  type: ProcessingType;
  priority: ProcessingPriority;
  material_type: string;
  quantity: number;
  unit: string;
  start_date?: string;
  notes?: string;
  assigned_to?: string;
  metadata?: Record<string, any>;
}

export interface UpdateProcessingBatchRequest {
  status?: ProcessingStatus;
  type?: ProcessingType;
  priority?: ProcessingPriority;
  material_type?: string;
  quantity?: number;
  unit?: string;
  start_date?: string;
  end_date?: string;
  notes?: string;
  quality_score?: number;
  efficiency_score?: number;
  assigned_to?: string;
  metadata?: Record<string, any>;
}

export type PaginatedProcessingResponse = PaginatedResponse<ProcessingBatchSchema>; 